import styled from "@rentiohq/web-theme";

// A choice's small line in the open menu. It inherits the option's color, so
// it reads on a highlighted option too.
export const OptionInfo = styled.div`
  font-size: 12px;
  line-height: 16px;
  opacity: 0.75;
`;
